import _ from "lodash";
import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";
import { ExpandingSelect } from "@/components/UI/ExpandingSelect";

export const MENTAL_STATUS_QUESTIONS = {
  affect: {
    label: "Affect",
    options: {
      appropriate: {
        answer: false,
        label: "Appropriate",
        order: 1,
      },
      broad: {
        answer: false,
        label: "Broad",
        order: 2,
      },
      flat: {
        answer: false,
        label: "Flat",
        order: 4,
      },
      inappropriate: {
        answer: false,
        label: "Inappropriate",
        order: 5,
      },
      restricted: {
        answer: false,
        label: "Restricted",
        order: 3,
      },
    },
    type: "multi",
  },
  appearance: {
    label: "Appearance",
    options: {
      disheveled: {
        answer: false,
        label: "Disheveled",
        order: 4,
      },
      healthy: {
        answer: false,
        label: "Healthy",
        order: 1,
      },
      inappropriate: {
        answer: false,
        label: "Inappropriate",
        order: 5,
      },
      neat: {
        answer: false,
        label: "Neat",
        order: 3,
      },
      sickly: {
        answer: false,
        label: "Sickly",
        order: 2,
      },
    },
    type: "single",
  },
  behavior: {
    label: "Behavior",
    options: {
      aggressive: {
        answer: false,
        label: "Aggressive",
        order: 5,
      },
      apathetic: {
        answer: false,
        label: "Apathetic",
        order: 3,
      },
      cooperative: {
        answer: false,
        label: "Cooperative",
        order: 1,
      },
      defensive: {
        answer: false,
        label: "Defensive",
        order: 4,
      },
      ingratiating: {
        answer: false,
        label: "Ingratiating",
        order: 2,
      },
    },
    type: "multi",
  },
  delusions: {
    label: "Delusions",
    options: {
      grandeur: {
        answer: false,
        label: "Grandeur",
        order: 4,
      },
      ideas_of_reference: {
        answer: false,
        label: "Ideas of reference",
        order: 5,
      },
      none: {
        answer: false,
        label: "No delusions",
        order: 1,
      },
      persecutory: {
        answer: false,
        label: "Persecutory",
        order: 2,
      },
      somatic: {
        answer: false,
        label: "Somatic",
        order: 3,
      },
    },
    type: "multi",
  },
  hallucinations: {
    label: "Hallucinations",
    options: {
      auditory: {
        answer: false,
        label: "Auditory",
        order: 2,
      },
      gustatory: {
        answer: false,
        label: "Gustatory",
        order: 6,
      },
      none: {
        answer: false,
        label: "No hallucinations",
        order: 1,
      },
      olfactory: {
        answer: false,
        label: "Olfactory",
        order: 5,
      },
      tactile: {
        answer: false,
        label: "Tactile",
        order: 4,
      },
      visual: {
        answer: false,
        label: "Visual",
        order: 3,
      },
    },
    type: "multi",
  },
  judgement: {
    label: "Judgement",
    options: {
      fair: {
        answer: false,
        label: "Fair",
        order: 2,
      },
      good: {
        answer: false,
        label: "Good",
        order: 1,
      },
      grossly_impaired: {
        answer: false,
        label: "Grossly Impaired",
        order: 5,
      },
      impaired: {
        answer: false,
        label: "Impaired",
        order: 4,
      },
      poor: {
        answer: false,
        label: "Poor",
        order: 3,
      },
    },
    type: "single",
  },
  memory: {
    label: "Memory",
    options: {
      immediate: {
        answer: false,
        label: "Immediate",
        order: 2,
      },
      long_term: {
        answer: false,
        label: "Long-term",
        order: 4,
      },
      none: {
        answer: false,
        label: "No memory problems",
        order: 1,
      },
      remote: {
        answer: false,
        label: "Remote",
        order: 5,
      },
      short_term: {
        answer: false,
        label: "Short-term",
        order: 3,
      },
    },
    type: "single",
  },
  mood: {
    label: "Mood",
    options: {
      anxious: {
        answer: false,
        label: "Anxious",
        order: 2,
      },
      dysphoric: {
        answer: false,
        label: "Dysphoric",
        order: 4,
      },
      euthymic: {
        answer: false,
        label: "Euthymic",
        order: 1,
      },
      grief_stricken: {
        answer: false,
        label: "Grief Stricken",
        order: 5,
      },
      irritable: {
        answer: false,
        label: "Irritable",
        order: 3,
      },
    },
    type: "single",
  },
  other_harm: {
    label: "Other’s Harm",
    options: {
      ideation: {
        answer: false,
        label: "Ideation",
        order: 2,
      },
      intent: {
        answer: false,
        label: "Intent",
        order: 4,
      },
      none: {
        answer: false,
        label: "None",
        order: 1,
      },
      plan: {
        answer: false,
        label: "Plan",
        order: 3,
      },
      recent: {
        answer: false,
        label: "Recent Attempt",
        order: 5,
      },
    },
    type: "single",
  },
  self_harm: {
    label: "Self-Harm",
    options: {
      ideation: {
        answer: false,
        label: "Ideation",
        order: 2,
      },
      intent: {
        answer: false,
        label: "Intent",
        order: 4,
      },
      none: {
        answer: false,
        label: "None",
        order: 1,
      },
      plan: {
        answer: false,
        label: "Plan",
        order: 3,
      },
      recent: {
        answer: false,
        label: "Recent Attempt",
        order: 5,
      },
    },
    type: "single",
  },
};

export const BehavioralMentalStatus = (props) => {
  const { createEditView, editable, editHandler, isCnaiEnabled, note, profileView, showTitle } =
    props;

  let mentalStatus = note.content.mental_status;

  const [editCopy, setEditCopy] = React.useState(_.cloneDeep(mentalStatus));

  const editHandlerBuilder = (sectionLabel, deeperLabels = []) => {
    return (e, index, key) => {
      let editCopyClone = _.cloneDeep(editCopy);

      let deeperObject = editCopyClone;

      deeperLabels.forEach((label) => {
        deeperObject = deeperObject[label];
      });
      deeperObject[index][key] = !deeperObject[index][key];

      if (index === "none") {
        Object.entries(deeperObject).forEach(([sectionKey, value]) => {
          if (sectionKey !== "none") {
            value[key] = false;
          }
        });
      } else {
        if (deeperObject["none"]) {
          deeperObject["none"][key] = false;
        }
      }

      setEditCopy(editCopyClone);
      editHandler(sectionLabel, editCopyClone);
    };
  };

  let title = showTitle ? (
    <div className="clr-sec tw:mb-2 tw:font-bold">Mental Status</div>
  ) : (
    <div />
  );

  let innerContent;

  if (!editable) {
    innerContent = (
      <>
        {title}
        <div className="row print-wrap">
          {Object.entries(editCopy).map(([key, value]) => {
            let answer = "None";
            let answerCombined = [];

            Object.entries(value.options).map(([optionKey, optionValue]) => {
              if (optionKey !== "none" && optionValue.answer) {
                answerCombined.push(optionValue.label);
              }
            });

            if (answerCombined.length > 0) {
              answer = answerCombined.join(", ");
            }

            let colCss = profileView || createEditView ? "col-12" : "col-6";

            return (
              <div className={`${colCss} my-1 py-1 fs-14 tw:justify-center`} key={key}>
                <label>
                  <input
                    checked={answer !== "None"}
                    className="custom-checkbox mr-2"
                    type="checkbox"
                  />
                  {value.label} - {answer}
                </label>
              </div>
            );
          })}
        </div>
      </>
    );
  } else {
    innerContent = (
      <>
        {title}
        <div className="tw:grid tw:grid-cols-2 tw:gap-4">
          {Object.entries(editCopy).map(([sectionKey, sectionValue]) => {
            return (
              <ExpandingSelect
                cnaiField={
                  isCnaiEnabled
                    ? {
                        id: `mental-status-${sectionKey}`,
                        name: sectionValue.label,
                        // every section renders as a checkbox group (see below) and
                        // editHandlerBuilder never enforces mutual exclusion between
                        // non-"none" options for "single"-type sections — only "none" is
                        // exclusive with the rest. So every section behaves like
                        // multiple_choice regardless of its `type`; tag it as such rather
                        // than declaring single_choice on a control that can't produce
                        // single-choice semantics (radio/select).
                        type: "multiple_choice",
                      }
                    : undefined
                }
                collapsible={false}
                key={sectionKey}
                label={sectionValue.label}
                labelClass="clr-sec"
                onChange={editHandlerBuilder("mental_status", [sectionKey, "options"])}
                options={sectionValue.options}
              />
            );
          })}
        </div>
      </>
    );
  }

  let content;

  if (!profileView) {
    content = (
      <CardSecondary className="mx-0 px-3 py-3 max-width" style={{ minHeight: 150 }}>
        {innerContent}
      </CardSecondary>
    );
  } else {
    content = (
      <div className="" style={{ minHeight: 150 }}>
        {innerContent}
      </div>
    );
  }

  return <>{content}</>;
};
